import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ICalendarState, RawActions, IEventFilter } from '@adage/ace-calendar';
import axios from 'axios';

import Dropdown from './dropdown';
import { IWACEvent, InputOption, ICalendarReduxState } from '../classes';
import { selectFilterOption } from "../redux/actions/index";

interface DropdownComponentExternalProps {
    filterKey: string;
    propertyToCompare: string;
    name: string;
    apiEndpoint: string;
}

interface StateToProps {
    selectedItem: string;
}

interface DropdownComponentDispatchProps {
    updateFilter: (matched: string) => any;
}

type DropdownComponentProps = DropdownComponentDispatchProps & StateToProps & DropdownComponentExternalProps;

interface DropdownComponentState {
    options: Array<InputOption>;
}

class DropdownComponent extends React.Component<DropdownComponentProps, DropdownComponentState> {

    constructor(props: DropdownComponentProps) {
        super(props);

        this.state = {
            options: []
        };
    }

    componentWillReceiveProps(props: DropdownComponentProps) {
        // If for whatever reason, the dropdown's selected item changes, update the filter.
        if (this.props.selectedItem !== props.selectedItem) {
            this.props.updateFilter(props.selectedItem);
        }
    }

    private boundOnChange = this.onChange.bind(this);

    onChange(newValue: string) {
        this.props.updateFilter(newValue);
    }

    render(): JSX.Element {
        return <Dropdown apiEndpoint={this.props.apiEndpoint} filterKey={this.props.filterKey} propertyToCompare={this.props.propertyToCompare} onChange={this.boundOnChange} name={this.props.name} />
    }
}

function comparison(property: string, expected: string) {
    return function (event: IWACEvent) {
        // This filter function should "reset" if the expected value is null, or there is no comparison value.
        if (!expected || expected.length === 0) {
            return true;
        }

        // Otherwise, if the property to be compared does not exist, it means it should not be returned.
        if (!event[property]) {
            return false;
        }

        if (event[property].constructor === Array) {
            const arr: Array<string> = event[property];

            return arr.indexOf(expected) > -1;
        }
        return event[property].toLowerCase() === expected.toLowerCase();
    }
}

function mapDispatchToProps(dispatch: Dispatch<ICalendarReduxState>, ownProps: DropdownComponentProps) {
    return {
        updateFilter: (matched: string) => {
            dispatch(RawActions.updateEventFilter({ key: ownProps.filterKey, filter: comparison(ownProps.propertyToCompare, matched) }))
        }
    }
}

function mapStateToProps(state: ICalendarReduxState, externalProps: DropdownComponentExternalProps) {
    return {
        selectedItem: state.filterModel.dropdownOptions[externalProps.filterKey]
    }
}


export default connect<StateToProps, DropdownComponentDispatchProps>(mapStateToProps, mapDispatchToProps)(DropdownComponent);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/components/desktop-dropdown.tsx